// In production, with create-react-app, we used register a service worker to serve assets from local cache
// As of January 2025, we're using Vite, so we're unregistering the service worker for all visitors

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((r) => r.forEach((r) => r.unregister()));
  }
}
